import { render, staticRenderFns } from "./OrderVanTab.vue?vue&type=template&id=5de7421d&scoped=true"
import script from "./OrderVanTab.vue?vue&type=script&lang=js"
export * from "./OrderVanTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7421d",
  null
  
)

export default component.exports